import React from 'react';
import { connect } from 'react-redux';
import { Typography, Button } from '@material-ui/core';
import Formsy from 'formsy-react';
import TextInput from 'components/inputs/TextInput';
import LoginMenu from 'components/menus/LoginMenu';
import { sendResetInstructions } from 'actions/ProfileActions';

export class ForgotPasswordPage extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data, _data, _invalidateForm) {
    this.props.sendResetInstructions(data.username);
  }

  render() {
    const { isProcessing } = this.props;

    return (
      <React.Fragment>
        <Typography variant="h4" align="center" className="top-space" gutterBottom>Forgot Password?</Typography>

        <Formsy onValidSubmit={this.handleSubmit}>
          <TextInput name="username" label="Username" compact required
            validationErrors={{
              isDefaultRequiredValue: "can't be blank"
            }}
          />

          <div className="login-button-container">
            <Button type="submit" disabled={isProcessing} variant="contained" color="primary">Reset Password</Button>
            <LoginMenu />
          </div>
        </Formsy>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isProcessing: state.profile.isProcessing
  }
}

const mapDispatchToProps = {
  sendResetInstructions: (username) => sendResetInstructions(username)
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage)
